import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#5A5B5E" fillRule="nonzero" transform="translate(-803 -338)">
          <g>
            <g transform="translate(295 150)">
              <g transform="translate(0 179)">
                <g transform="translate(499)">
                  <path d="M20.193 12.004l3.661 3.68-9.268 9.313-3.66-3.68 9.267-9.313zm6.44-.887L25 9.476a1.615 1.615 0 00-2.29 0l-1.563 1.571 3.661 3.68 1.825-1.833c.49-.492.49-1.286 0-1.777zM9.01 26.49a.418.418 0 00.504.498l4.08-.994-3.659-3.68-.925 4.176z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;



// WEBPACK FOOTER //
// src/icons/icon_pencil.js